var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.availableLocales.length === 1)?_c('div',[_c('nuxt-link',{staticClass:"switch-language",attrs:{"to":_vm.switchLocalePath(_vm.availableLocales[0].slug)}},[_vm._v("\n    "+_vm._s(_vm.availableLocales[0].slug[0].toUpperCase() + _vm.availableLocales[0].slug.substring(1))+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }